import React from "react";
import { useNavigate } from "react-router-dom";
import LeftArrowIcon from "../../assets/svgs/left-arrow.svg";
import RightArrowIcon from "../../assets/svgs/right-arrow.svg";
import BackArrowIcon from "../../assets/svgs/back_arrow.svg";
import styles from "./ExitCalendarCustomToolbar.module.css";

const ExitCalendarCustomToolbar = ({ label, onNavigate, isAdmin }) => {
    const navigate = useNavigate();

    const handleAdminClick = () => {
        navigate("/admin");
    };

    return (
        <div className={styles.toolbar}>
            <span className={styles.navigation}>
                <span
                    className={`${styles.navArrowWrapper} ${styles.leftArrowWrapper}`}
                    onClick={() => onNavigate("PREV")}
                >
                    <img
                        src={LeftArrowIcon}
                        alt="Mes anterior"
                        className={`${styles.navArrow} ${styles.leftArrow}`}
                    />
                </span>
                <span className={styles.toolbarLabel}>{label}</span>
                <span
                    className={`${styles.navArrowWrapper} ${styles.rightArrowWrapper}`}
                    onClick={() => onNavigate("NEXT")}
                >
                    <img
                        src={RightArrowIcon}
                        alt="Mes siguiente"
                        className={`${styles.navArrow} ${styles.rightArrow}`}
                    />
                </span>
            </span>

            {isAdmin && (
                <span className={styles.viewButtons}>
                    <button
                        type="button"
                        className={styles.backButton}
                        onClick={handleAdminClick}
                    >
                        <img
                            src={BackArrowIcon}
                            alt=""
                            aria-hidden="true"
                            className={styles.backIcon}
                        />
                        <span>Ver todos los empleados</span>
                    </button>
                </span>
            )}
        </div>
    );
};

export default ExitCalendarCustomToolbar;
